var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyPregnancy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 160,
    viewBox: "0 0 241 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.366,
    cy: 79.8651,
    rx: 49.3702,
    ry: 49.4667,
    fill: "#F7F7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.305 137.114L178.593 131.391M162.599 133.68C172.694 133.68 180.878 125.48 180.878 115.365C180.878 105.251 172.694 97.0508 162.599 97.0508C152.504 97.0508 144.32 105.251 144.32 115.365C144.32 125.48 152.504 133.68 162.599 133.68Z",
    stroke: "#D9D8DF",
    strokeWidth: 9.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.03 26.5703H68.0182C65.0785 26.5703 62.6953 28.9581 62.6953 31.9036V98.8378C62.6953 101.783 65.0785 104.171 68.0182 104.171H121.03C123.969 104.171 126.353 101.783 126.353 98.8378V31.9036C126.353 28.9581 123.969 26.5703 121.03 26.5703Z",
    fill: "#FDFDFD",
    stroke: "#D9D8DF",
    strokeWidth: 1.65333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1887 41.6641H87.8341C80.9531 41.6641 75.375 47.2531 75.375 54.1475V63.5203C75.375 70.4148 80.9531 76.0038 87.8341 76.0038H97.1887C104.07 76.0038 109.648 70.4148 109.648 63.5203V54.1475C109.648 47.2531 104.07 41.6641 97.1887 41.6641Z",
    fill: "#8F8FA1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.3 66.0378V67.1858C100.3 67.8197 99.7932 68.3341 99.1691 68.3341H85.5996C84.9755 68.3341 84.4688 67.8197 84.4688 67.1858V66.0194C84.4688 62.5453 88.379 60.2882 92.3842 60.2882C96.3895 60.2882 100.3 62.5464 100.3 66.0194M95.2222 50.2018C96.7903 51.7728 96.7903 54.32 95.2222 55.8912C93.6543 57.4621 91.112 57.4621 89.5442 55.8912C87.976 54.32 87.976 51.7728 89.5442 50.2018C91.112 48.6306 93.6543 48.6306 95.2222 50.2018Z",
    fill: "#FDFDFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.348 87.4492H74.2961C73.1876 87.4492 72.2891 88.3495 72.2891 89.4602C72.2891 90.5708 73.1876 91.4711 74.2961 91.4711H111.348C112.456 91.4711 113.355 90.5708 113.355 89.4602C113.355 88.3495 112.456 87.4492 111.348 87.4492Z",
    fill: "#D9D8DF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.039 79.4062H74.6048C73.3259 79.4062 72.2891 80.4451 72.2891 81.7265C72.2891 83.008 73.3259 84.0468 74.6048 84.0468H111.039C112.318 84.0468 113.355 83.008 113.355 81.7265C113.355 80.4451 112.318 79.4062 111.039 79.4062Z",
    fill: "#D9D8DF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.039 94.875H74.6048C73.3259 94.875 72.2891 95.9138 72.2891 97.1953C72.2891 98.4767 73.3259 99.5155 74.6048 99.5155H111.039C112.318 99.5155 113.355 98.4767 113.355 97.1953C113.355 95.9138 112.318 94.875 111.039 94.875Z",
    fill: "#D9D8DF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6704 34.5484C71.6704 33.3524 70.7027 32.3828 69.509 32.3828C68.3153 32.3828 67.3477 33.3524 67.3477 34.5484C67.3477 35.7444 68.3153 36.714 69.509 36.714C70.7027 36.714 71.6704 35.7444 71.6704 34.5484Z",
    fill: "#D9D8DF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8462 34.5484C77.8462 33.3524 76.8785 32.3828 75.6848 32.3828C74.4911 32.3828 73.5234 33.3524 73.5234 34.5484C73.5234 35.7444 74.4911 36.714 75.6848 36.714C76.8785 36.714 77.8462 35.7444 77.8462 34.5484Z",
    fill: "#D9D8DF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M84.022 34.5484C84.022 33.3524 83.0543 32.3828 81.8606 32.3828C80.6669 32.3828 79.6992 33.3524 79.6992 34.5484C79.6992 35.7444 80.6669 36.714 81.8606 36.714C83.0543 36.714 84.022 35.7444 84.022 34.5484Z",
    fill: "#D9D8DF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M136.867 81.7266C136.867 91.1421 129.454 98.7266 120.367 98.7266C111.281 98.7266 103.867 91.1421 103.867 81.7266C103.867 72.311 111.281 64.7266 120.367 64.7266C129.454 64.7266 136.867 72.311 136.867 81.7266Z",
    fill: "#F7F7F8",
    stroke: "#006546",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.364 77.7861C121.223 74.1747 126.347 72.8046 129.253 75.8179C130.45 77.0589 131.117 78.7319 131.117 80.4693C131.117 82.2068 130.45 83.8799 129.253 85.1208C128.456 85.9464 127.661 86.7907 126.862 87.6394C125.238 89.3633 123.597 91.1056 121.893 92.7471L121.889 92.7509C121.01 93.585 119.618 93.5548 118.776 92.6825L111.481 85.1207C108.996 82.5445 108.996 78.3942 111.481 75.818C113.913 73.297 119.455 73.5873 120.364 77.7861Z",
    fill: "#006546"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPregnancy);
export default __webpack_public_path__ + "static/media/empty-pregnancy.1b5058f36e36912ed2d069190e54598a.svg";
export { ForwardRef as ReactComponent };